
const videoLightbox = GLightbox({
    selector: '.glightbox-video',
    touchNavigation: true,
    loop: false,
    autoplayVideos: true
});

// Timeline Swiper initialization
const timelineSwiper = new Swiper('.timeline-swiper', {
    slidesPerView: 'auto',
    spaceBetween: 40,
    navigation: {
        nextEl: '.timeline-swiper-next',
        prevEl: '.timeline-swiper-prev',
    },
    loop: true,
    grabCursor: false,
    breakpoints: {
        1024: {
            slidesPerView: 2.2,
        },
        640: {
            slidesPerView: 1.2,
        },
        0: {
            slidesPerView: 1,
        }
    }
});
